export default "__VITE_ASSET___vKijFT___"